import Callout from 'client/js/util/callout';
import ExternalLink from 'client/js/util/external_link';
import LoadingTableSpinner from 'client/js/util/loading_table_spinner';

import {Redirect} from 'react-router-dom';
import PrepaidStep from "client/js/usercp/cloud/create_account/prepaid_step";
import {FormActions} from 'client/js/util/form_utils';
import {PageHeader, HelpTooltip, FaIcon} from 'client/js/util/layout_utils';

import Cards from 'react-credit-cards';

import {GenericReactForm, StringInput, RadioCollectionInput, BooleanInput, SelectCollectionInput,
  IbanInput, ChangeSelectionInput, MultistepReactForm, SubmitButton, SimpleSubmitButton} from 'client/js/util/form_utils';
import StreetAndNumberInput from 'client/js/util/inputs/street_and_number_input';
import PostalAndCityInput from 'client/js/util/inputs/postal_and_city_input';

import {CreditCardNumberInput, CreditCardExpiryInput} from 'client/js/util/credit_card_inputs';

import 'react-credit-cards/lib/styles-compiled.css';

class AddCreditCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {submitted: false, number: "", exp: "", cvc: ""};

    this.dispatch = this.dispatch.bind(this);
  }

  componentDidMount() {
    if(typeof(Stripe) === 'undefined')
      $.getScript('https://js.stripe.com/v2/', () => {
        Stripe.setPublishableKey(window.StripePublishableKey);
      });
    else
      Stripe.setPublishableKey(window.StripePublishableKey);
  }

  dispatch(action, original_event, data) {
    console.log(`AddCreditCard dispatch: got ${action} with data:`, data);

    if(action == 'focus') {
      this.setState({focus: original_event.target.name});
    }

    if(action == 'value_changed') {
      this.setState((prevState, props) => {
        prevState[data.name] = data.value;
        return prevState;
      })
    }

    if(action == 'submit') {
      original_event.preventDefault();
      this.setState({submitting: true});

      Stripe.card.createToken(original_event.currentTarget, (status, response) => {
        if (response.error) {
          // Show the errors on the form
          var i18n_err;
          if(response.error.type == 'card_error') {
            i18n_err = I18n_usercp.cc_errors[response.error.code];
          } else {
            i18n_err = response.error.message;
          }

          this.setState({formError: i18n_err, submitting: false});
        } else {
          // we are not setting the submitting to false, because loading is not finished
          this.setState({formError: null});

          let token = response.id;
          let last4 = response.card.last4;

          $.post('/usercp/payment_methods.json', {type: 'credit_card', default_for: "", usercp_new_payment_method: {stripe_token: token, last4: last4}})
          .done((data) => {
            this.props.dispatch('payment_method_added', null, data);
          })
          .fail((response, b, c) => {
            var error_text = 'Bei der Übermittlung der Daten ist ein Fehler aufgetreten!';
            if(response.status == 402) {
              try {
                var json_response = JSON.parse(response.responseText)
                error_text = I18n_usercp.cc_errors[json_response.code];
              } catch(e) {}
            }

            this.setState({formError: error_text});
          }).always(() => {
            this.setState({submitting: false});
          });
        }
      });
    }

    // if(action == 'value_change')
    if(action == 'form:success') {
      this.props.dispatch('payment_method_added', null, data);
    }
  }

  render() {
    return (<form id="new_usercp_payment_methods_create_credit_card" className="mb-4" onSubmit={(e) => this.dispatch('submit', e)}>
            <SubformHeader text="Kreditkarte anlegen" goBack={this.props.goBack} />
            <div className={`row form-group credit_card_display`}>
              <div className="col-md-9 offset-md-3">

                <Cards
                  number={this.state.number.replace(/[^\d]+/g, '')}
                  name="MAX MUSTERMANN"
                  expiry={this.state.exp.replace(/[^\d\/ ]+/g, '').replace(/ /g, '')}
                  cvc={this.state.cvc.replace(/[^\d]+/g, '')}
                  focused={this.state.focus}
                />
              </div>
            </div>

            <div className={`row form-group credit_card_inputs ${this.state.formError && 'error'}`}>
              <div className="col-md-9 offset-md-3">
                <div className="cc-field-wrapper cc-card">
                  <CreditCardNumberInput onFocus={(e) => this.dispatch('focus', e)} dispatch={this.dispatch} />
                  <span className="input-icon">
                    <FaIcon name="credit-card fa-fw" />
                  </span>
                </div>
                <div className="cc-field-wrapper">
                  <CreditCardExpiryInput onFocus={(e) => this.dispatch('focus', e)} dispatch={this.dispatch} />
                  <span className="input-icon">
                    <FaIcon name="calendar fa-fw" />
                  </span>
                </div>
                <div className="cc-field-wrapper">
                  <input className="form-control cc-cvc" type="tel" onFocus={(e) => this.dispatch('focus', e)} onChange={(e) => this.dispatch('value_changed', e, {name: 'cvc', value: e.target.value})} name="cvc" data-stripe='cvc' placeholder='CVC' size="3" autoComplete='off' required dispatch={this.dispatch} maxLength="4" />
                  <span className="input-icon">
                    <FaIcon name="lock fa-fw" />
                  </span>
                </div>

                <div className="help-block payment-errors">{this.state.formError}</div>
              </div>
            </div>

            <FormActions>
              <SimpleSubmitButton submitting={this.state.submitting} icon="plus" text="Kreditkarte anlegen" />
            </FormActions>
      </form>);

    if(this.state.paymentMethod)
      return null;
  }
}

class AddDirectDebit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {submitted: false};

    this.dispatch = this.dispatch.bind(this);
  }

  dispatch(action, original_event, data) {
    console.log(`AddDirectDebit dispatch: got ${action} with data:`, data);

    // if(action == 'value_change')
    if(action == 'form:success') {
      this.setState({paymentMethod: data.payment_method});
    }

    if(action == 'proceed') {
      this.props.dispatch('payment_method_added', null, this.state.paymentMethod);
      original_event.preventDefault();
    }
  }

  render() {
    if(this.state.paymentMethod)
      return (<div className="mb-4">
                <SubformHeader text="Bankverbindung anlegen" goBack={this.props.goBack} />

                <p className='alert alert-success'>
                  Wir haben die SEPA-Bankverbindung angelegt. Bitte prüfe in den nächsten 1-2 Tagen Deinen Kontoauszug und gib den erhaltenen Code in der Verwaltung ein.
                </p>
                <div className='inline-actions'>
                  <a href="#" onClick={(e) => this.dispatch('proceed', e)} className="btn btn-primary">Okay! &rarr;</a>
                </div>
              </div>);

    return <div className="create-sepa-direct-debit mb-4">
          <SubformHeader text="SEPA-Bankverbindung anlegen" goBack={this.props.goBack} />

          <Callout title="Hinweis" calloutClass="primary">Um von europäischen Bankkonten automatisch per SEPA-Lastschrift zahlen zu können muss die Bankverbindung verifiziert werden. Dazu überweisen wir einen Betrag von 1 Cent auf Dein Konto mit einem Code im Verwendungszweck. Das Konto ist bestätigt, sobald Du diesen Code hier eingibst.</Callout>

          <GenericReactForm defaults={{lang: (navigator.language || navigator.userLanguage)}} namespace="usercp_payment_methods_create_direct_debit" url="/usercp/payment_methods" dispatch={this.dispatch}>
            <StringInput required name="account_holder" label="Kontoinhaber" autoComplete='name'  />
            <IbanInput required name="iban" label='IBAN' autoComplete='iban' />
            <BooleanInput required name="compliance_accepted" label={<span>Ich habe verstanden, dass ich die Bankverbindung zuerst mit einem 6-stelligen Code, der auf mein Konto überwiesen wird, bestätigen muss. <strong>Der Cloud-Account ist bis zur Bestätigung der Bankverbindung nicht aktiv. Ich kann zur Nutzung der Cloud vor der Bestätigung Guthaben auf mein Kundenkonto aufladen.</strong></span>} />

            <FormActions>
              <SubmitButton icon="plus" text="SEPA-Bankverbindung anlegen" />
            </FormActions>
          </GenericReactForm>
        </div>;
  }
}

class AddBillingHandle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {submitted: false};

    this.dispatch = this.dispatch.bind(this);
  }

  dispatch(action, original_event, data) {
    console.log(`AddBillingHandle dispatch: got ${action} with data:`, data);

    // if(action == 'value_change')
    if(action == 'form:success') {
      this.props.dispatch('billing_handle_added', null, data.object);
    }

    if(action == 'form:change' && data.changedField == 'role_type') {
      this.setState({showOrganisation: data.formData.role_type == 'ORG'});
    }

  }

  render() {
    const options = {"PERS": "Person oder Einzelunternehmer", "ORG": "Unternehmen, Verein oder Organisation"}

    const countries = [["DE","Germany"],["AT","Austria"],["CH","Switzerland"],["AF","Afghanistan"],["AL","Albania"],["DZ","Algeria"],["AS","American Samoa"],["AD","Andorra"],["AO","Angola"],["AI","Anguilla"],["AQ","Antarctica"],["AG","Antigua and Barbuda"],["AR","Argentina"],["AM","Armenia"],["AW","Aruba"],["AU","Australia"],["AZ","Azerbaijan"],["BS","Bahamas"],["BH","Bahrain"],["BD","Bangladesh"],["BB","Barbados"],["BY","Belarus"],["BE","Belgium"],["BZ","Belize"],["BJ","Benin"],["BM","Bermuda"],["BT","Bhutan"],["BO","Bolivia"],["BQ","Bonaire, Sint Eustatius and Saba"],["BA","Bosnia and Herzegovina"],["BW","Botswana"],["BV","Bouvet Island"],["BR","Brazil"],["IO","British Indian Ocean Territory"],["BN","Brunei Darussalam"],["BG","Bulgaria"],["BF","Burkina Faso"],["BI","Burundi"],["KH","Cambodia"],["CM","Cameroon"],["CA","Canada"],["CV","Cape Verde"],["KY","Cayman Islands"],["CF","Central African Republic"],["TD","Chad"],["CL","Chile"],["CN","China"],["CX","Christmas Island"],["CC","Cocos (Keeling) Islands"],["CO","Colombia"],["KM","Comoros"],["CG","Congo"],["CD","Congo, The Democratic Republic Of The"],["CK","Cook Islands"],["CR","Costa Rica"],["HR","Croatia"],["CU","Cuba"],["CW","Curaçao"],["CY","Cyprus"],["CZ","Czech Republic"],["CI","Côte D'Ivoire"],["DK","Denmark"],["DJ","Djibouti"],["DM","Dominica"],["DO","Dominican Republic"],["EC","Ecuador"],["EG","Egypt"],["SV","El Salvador"],["GQ","Equatorial Guinea"],["ER","Eritrea"],["EE","Estonia"],["ET","Ethiopia"],["FK","Falkland Islands (Malvinas)"],["FO","Faroe Islands"],["FJ","Fiji"],["FI","Finland"],["FR","France"],["GF","French Guiana"],["PF","French Polynesia"],["TF","French Southern Territories"],["GA","Gabon"],["GM","Gambia"],["GE","Georgia"],["GH","Ghana"],["GI","Gibraltar"],["GR","Greece"],["GL","Greenland"],["GD","Grenada"],["GP","Guadeloupe"],["GU","Guam"],["GT","Guatemala"],["GG","Guernsey"],["GN","Guinea"],["GW","Guinea-Bissau"],["GY","Guyana"],["HT","Haiti"],["HM","Heard and McDonald Islands"],["VA","Holy See (Vatican City State)"],["HN","Honduras"],["HK","Hong Kong"],["HU","Hungary"],["IS","Iceland"],["IN","India"],["ID","Indonesia"],["IR","Iran, Islamic Republic Of"],["IQ","Iraq"],["IE","Ireland"],["IM","Isle of Man"],["IL","Israel"],["IT","Italy"],["JM","Jamaica"],["JP","Japan"],["JE","Jersey"],["JO","Jordan"],["KZ","Kazakhstan"],["KE","Kenya"],["KI","Kiribati"],["KP","Korea, Democratic People's Republic Of"],["KR","Korea, Republic of"],["KW","Kuwait"],["KG","Kyrgyzstan"],["LA","Lao People's Democratic Republic"],["LV","Latvia"],["LB","Lebanon"],["LS","Lesotho"],["LR","Liberia"],["LY","Libya"],["LI","Liechtenstein"],["LT","Lithuania"],["LU","Luxembourg"],["MO","Macao"],["MK","Macedonia, the Former Yugoslav Republic Of"],["MG","Madagascar"],["MW","Malawi"],["MY","Malaysia"],["MV","Maldives"],["ML","Mali"],["MT","Malta"],["MH","Marshall Islands"],["MQ","Martinique"],["MR","Mauritania"],["MU","Mauritius"],["YT","Mayotte"],["MX","Mexico"],["FM","Micronesia, Federated States Of"],["MD","Moldova, Republic of"],["MC","Monaco"],["MN","Mongolia"],["ME","Montenegro"],["MS","Montserrat"],["MA","Morocco"],["MZ","Mozambique"],["MM","Myanmar"],["NA","Namibia"],["NR","Nauru"],["NP","Nepal"],["NL","Netherlands"],["AN","Netherlands Antilles"],["NC","New Caledonia"],["NZ","New Zealand"],["NI","Nicaragua"],["NE","Niger"],["NG","Nigeria"],["NU","Niue"],["NF","Norfolk Island"],["MP","Northern Mariana Islands"],["NO","Norway"],["OM","Oman"],["PK","Pakistan"],["PW","Palau"],["PS","Palestinian Territory, Occupied"],["PA","Panama"],["PG","Papua New Guinea"],["PY","Paraguay"],["PE","Peru"],["PH","Philippines"],["PN","Pitcairn"],["PL","Poland"],["PT","Portugal"],["PR","Puerto Rico"],["QA","Qatar"],["RO","Romania"],["RU","Russian Federation"],["RW","Rwanda"],["RE","Réunion"],["BL","Saint Barthélemy"],["SH","Saint Helena"],["KN","Saint Kitts And Nevis"],["LC","Saint Lucia"],["MF","Saint Martin"],["PM","Saint Pierre And Miquelon"],["VC","Saint Vincent And The Grenedines"],["WS","Samoa"],["SM","San Marino"],["ST","Sao Tome and Principe"],["SA","Saudi Arabia"],["SN","Senegal"],["RS","Serbia"],["SC","Seychelles"],["SL","Sierra Leone"],["SG","Singapore"],["SX","Sint Maarten"],["SK","Slovakia"],["SI","Slovenia"],["SB","Solomon Islands"],["SO","Somalia"],["ZA","South Africa"],["GS","South Georgia and the South Sandwich Islands"],["SS","South Sudan"],["ES","Spain"],["LK","Sri Lanka"],["SD","Sudan"],["SR","Suriname"],["SJ","Svalbard And Jan Mayen"],["SZ","Swaziland"],["SE","Sweden"],["SY","Syrian Arab Republic"],["TW","Taiwan, Republic Of China"],["TJ","Tajikistan"],["TZ","Tanzania, United Republic of"],["TH","Thailand"],["TL","Timor-Leste"],["TG","Togo"],["TK","Tokelau"],["TO","Tonga"],["TT","Trinidad and Tobago"],["TN","Tunisia"],["TR","Turkey"],["TM","Turkmenistan"],["TC","Turks and Caicos Islands"],["TV","Tuvalu"],["UG","Uganda"],["UA","Ukraine"],["AE","United Arab Emirates"],["GB","United Kingdom"],["US","United States"],["UM","United States Minor Outlying Islands"],["UY","Uruguay"],["UZ","Uzbekistan"],["VU","Vanuatu"],["VE","Venezuela, Bolivarian Republic of"],["VN","Vietnam"],["VG","Virgin Islands, British"],["VI","Virgin Islands, U.S."],["WF","Wallis and Futuna"],["EH","Western Sahara"],["YE","Yemen"],["ZM","Zambia"],["ZW","Zimbabwe"],["AX","Åland Islands"]];

    return (
      <GenericReactForm defaults={{role_type: 'PERS'}} namespace="handle" url="/usercp/handles" dispatch={this.dispatch}>
        <RadioCollectionInput required name="role_type" label="Typ" options={options} />
        {this.state.showOrganisation && <StringInput name="organisation" label='Firma, Vereinsname' placeholder='Muster GmbH/e.V.' required />}

        <StringInput name="firstname" label="Vorname" required />
        <StringInput name="lastname" label="Nachname" required />

        <StreetAndNumberInput label="Straße und Hausnummer" />
        <PostalAndCityInput label="Postleitzahl und Ort" />
        <SelectCollectionInput name="country" label="Land" required options={countries} />

        <StringInput name="email" label="E-Mail-Adresse" required />
        <StringInput name="phone" label="Telefon" required type="tel" />
        <StringInput name="fax" label="Fax" type="tel" />

        <FormActions>
          <SubmitButton icon="plus" text="Adresse anlegen" />
        </FormActions>
      </GenericReactForm>);
  }
}

const SubformHeader = function(props) {
  return <div className="row">
           <div className="col-md-9 offset-md-3">
             {props.goBack ? <a href="#" onClick={(e) => props.goBack(e)}>←</a> : null}
             <h4>{props.text}</h4>
           </div>
         </div>;
}

class SelectBillingHandle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {data: null};

    this.dispatch = this.dispatch.bind(this);
  }

  componentDidMount() {
    this.reload();
  }

  reload() {
    $.get('/usercp/handles.json')
      .done((data, x, y) => {
        this.setState({data: data.handles})
      });
  }

  dispatch(action, original_event, data) {
    console.log(`SelectBillingHandle dispatch: got ${action} with data:`, data);

    if(action == 'add_new') {
      original_event.preventDefault();
      this.setState({formOpen: true});
    }

    if(action == 'cancel_new') {
      original_event.preventDefault();
      this.setState({formOpen: false});
    }

    if(action == 'billing_handle_added') {
      this.setState({formOpen: false});
      this.props.dispatch && this.props.dispatch('billing_handle_added', null, data);
    }
  }

  render() {
    if(this.state.data == null)
      return <LoadingTableSpinner text="Lade Rechnungsadressen..."/>

    if(this.state.data.length == 0 || this.state.formOpen) {
      return <div className="mb-4">
        <SubformHeader text="Rechungsadresse anlegen" goBack={this.state.data.length && ((e) => {this.dispatch('cancel_new', e)})} />

        <AddBillingHandle dispatch={this.dispatch} />
      </div>;
    }

    const options = this.state.data.map((item) => ([item.id, item.friendly_name]));

    return (<div>
            <RadioCollectionInput required name="billing_handle_id" label="Rechnungsadresse" options={options} />

            <div className="row form-group">
              <div className="col-md-9 offset-md-3"><a href="#" onClick={(e) => this.dispatch('add_new', e)}>Neue Rechnungsadresse anlegen</a></div>
            </div>
          </div>);
  }
}

class SelectPaymentMethod extends React.Component {
  constructor(props) {
    super(props);
    this.state = {payment_methods: null};

    this.dispatch = this.dispatch.bind(this);
  }

  componentDidMount() {
    this.reload();
  }

  reload() {
    $.get('/usercp/payment_methods.json')
      .done((data, x, y) => {
        const filtered_m = data.payment_methods.filter((item, i) => (item.type == this.props.payment_method) )

        this.setState({payment_methods: filtered_m})
      });
  }

  dispatch(action, original_event, data) {
    console.log(`SelectPaymentMethod dispatch: got ${action} with data:`, data);

    if(action == 'add_new')
      this.setState({formOpen: true});

    if(action == 'abort_add')
      this.setState({formOpen: false});

    if(action == 'payment_method_added') {
      this.setState({formOpen: false});
      this.props.dispatch && this.props.dispatch('payment_method_added', null, data);
    }
  }

  render() {
    if(this.state.payment_methods == null)
      return <LoadingTableSpinner text="Lade Zahlungsmethoden..."/>

    if(this.state.payment_methods.length == 0 || this.state.formOpen) {
      if(this.props.payment_method == 'direct_debit')
        return <AddDirectDebit dispatch={this.dispatch} goBack={this.state.payment_methods.length && ((e) => this.dispatch('abort_add', e))} />;
      else
        return <AddCreditCard dispatch={this.dispatch} goBack={this.state.payment_methods.length && ((e) => this.dispatch('abort_add', e))} />;
    }

    const options = this.state.payment_methods.map((item) => ([item.id, item.friendly_name]));

    return (<div className="mb-4">
            <RadioCollectionInput required name="payment_method_id" label={this.props.label} options={options} />

            <div className="row form-group">
              <div className="col-md-9 offset-md-3"><a href="#" onClick={(e) => this.dispatch('add_new', e)}>Neue {this.props.label} anlegen</a></div>
            </div>
          </div>);
  }
}

var FormPartial = function(props) {
  if(props.isOpen && props.children)
    return <div>{props.children}</div>;
  else
    return null;
}



var EnableAccountForm = function(props) {
  const payment_methods = {
    prepaid: <span>Vorauszahlung/vorherige Aufladung von Guthaben <HelpTooltip content="Du lädst vor der Verwendung von Cloud-VPS Guthaben per PayPal, SOFORT Überweisung, Überweisung, Kreditkarte, paysafecard oder Bitcoin auf." /></span>,
    credit_card: 'Kreditkarte',
    //direct_debit: 'SEPA-Lastschrift'
  };

  const pm_name = props.payment_method == 'direct_debit' ? 'Bankverbindung' : payment_methods[props.payment_method];
  const the_pm_name = props.payment_method_label;

  let step = 1;
  if(props.billing_handle_id !== undefined && props.billing_handle_id !== null) {
    step = 2;

    if(props.payment_method) {
      step = 3;

      if(props.payment_method == 'prepaid' || props.payment_method_id) {
        step = 4;

        if(props.tosAccepted == '1')
          step = 5;
      }
    }
  }

  console.log('I am at step', step)

  return <div>
    <PageHeader text="Cloud-Zugang" />
    <MultistepReactForm step={step} finalStep={5} namespace="cloud_account" url="/usercp/cloud_account.json" dispatch={props.dispatch}>
      <FormPartial isOpen={step == 1}>
        <div className="row">
          <div className="col-md-9 offset-md-3 mb-4">
            <button className="btn btn-secondary btn-sm" onClick={(e) => props.dispatch('no_billing_handle', e)}>Rechnungsadresse überspringen →</button>
          </div>
        </div>

        <SelectBillingHandle dispatch={props.dispatch} />
      </FormPartial>

      <FormPartial isOpen={step >= 2}>
        {/* billing handle changer */}
        <ChangeSelectionInput required name="billing_handle_id" label="Rechnungsadresse">{props.billing_handle_id ? props.billing_handle_label : 'keine Rechnungsadresse angegeben'}</ChangeSelectionInput>
      </FormPartial>

      <FormPartial isOpen={step == 2}>
        <RadioCollectionInput required name="payment_method" label="Zahlungsmethode" options={payment_methods} />
      </FormPartial>

      <FormPartial isOpen={step >= 3}>
        <ChangeSelectionInput required name="payment_method" label="Zahlungsmethode">{payment_methods[props.payment_method]}</ChangeSelectionInput>
      </FormPartial>

      <FormPartial isOpen={step == 3}>
        <FormPartial isOpen={props.payment_method == 'credit_card'}>
          <SelectPaymentMethod payment_method="credit_card" label='Kreditkarte' payment_methods={props.credit_cards} dispatch={props.dispatch} />
        </FormPartial>

        <FormPartial isOpen={props.payment_method == 'direct_debit'}>
          <SelectPaymentMethod payment_method="direct_debit" label='Bankverbindung' payment_methods={props.direct_debits} dispatch={props.dispatch} />
        </FormPartial>
      </FormPartial>

      <FormPartial isOpen={step >= 3 && props.payment_method_id}>
        {/* payment method changer */}
        <ChangeSelectionInput required name="payment_method_id" label={pm_name}>{the_pm_name}</ChangeSelectionInput>
      </FormPartial>

      <FormPartial isOpen={false && step >= 3 && props.payment_method == 'prepaid'}>
        {/* payment method changer */}
        <PrepaidStep />
      </FormPartial>

      <FormPartial isOpen={step >= 4}>
        <BooleanInput name="tos_accepted" required checked={props.tosAccepted == '1'}
                  label={<span>Ich akzeptiere die <ExternalLink href="/AGB.pdf">allgemeinen Geschäftsbedingungen</ExternalLink> und die <ExternalLink href="/Leistungsbeschreibung Cloud-Services.pdf">Leistungsbeschreibung für Cloud-Services</ExternalLink>.</span>} />
      </FormPartial>

      <FormActions>
        <SubmitButton icon="cloud" disabled={step != 5} text="Cloud-Zugang erstellen" />
      </FormActions>
    </MultistepReactForm></div>;
}

const CreateAccountSplash = function(props) {
  return <Callout title="Cloud-Account erstellen">
          <p>Um Cloud-VPS zu nutzen muss ein Cloud-Account angelegt werden. Über das Cloud-Account werden die Cloud-Services abgerechnet. Bitte wähle dazu im folgenden eine Rechnungsadresse<sup>1</sup> und eine Zahlungsmethode (Kreditkarte, SEPA-Lastschrift, Vorkasse/Aufladung von Guthaben) aus.</p>

          <p><strong>vServer werden unabhängig von einem Cloud-Account über den Shop gebucht, für vServer ist kein Cloud-Account notwendig!</strong></p>

          <p>Das Cloud-Account ist vollkommen kostenlos, es können darüber aber zahlungspflichtige Services gebucht werden.</p>
          <p>Die Cloud-Services werden jeweils am Monatsersten für den vorherigen Monat abgerechnet. Es kann ein "Live-Kontostand" mit aktuellen Abrechnungspositionen eingesehen werden. Bei der Zahlung per Vorkasse ist eine teilweise oder vollständige Vorauszahlung des voraussichtlich anfallenden monatlichen Rechnungsbetrags zu leisten.</p>

          <p><button className="btn btn-primary" onClick={(e) => props.cb(e)}>Cloud-Account erstellen →</button></p>

          <p><small><sup>1</sup> Ohne die Angabe einer Rechnungsadresse ist das Cloud-Account auf einen monatlichen Rechnungsbetrag von 100 € limitiert.</small></p>
        </Callout>;
}

class CreateAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.dispatch = this.dispatch.bind(this);
    this.handleModalClick = this.handleModalClick.bind(this);
  }

  dispatch(action, original_event, data) {
    console.log(`CloudAccessForm dispatch: got ${action} with`, data);

    if(action == 'no_billing_handle') {
      original_event.preventDefault();
      this.setState({ billing_handle_id: false, billing_handle_label: "nicht angegeben" });
    }

    if(action == 'form:change') {
      if(data.changedField == 'billing_handle_id')
        this.setState({ billing_handle_id: data.formData.billing_handle_id,
                        billing_handle_label: data.label });

      if(data.changedField == 'payment_method')
        this.setState({ payment_method: data.formData.payment_method,
                        payment_method_id: null,
                        payment_method_label: data.label });

      if(data.changedField == 'payment_method_id')
        this.setState({ payment_method_id: data.formData.payment_method_id,
                        payment_method_label: data.label });

      if(data.changedField == 'tos_accepted')
        this.setState({ tosAccepted: data.formData.tos_accepted });
    } else if(action == 'payment_method_added') {
      this.setState({ payment_method_id: data.id, payment_method_label: data.friendly_name });
    } else if(action == 'billing_handle_added') {
      this.setState({ billing_handle_id: data.id, billing_handle_label: data.friendly_name });
    } else if(action == 'form:success') {
      this.setState({ready: true});
    }
  }

  handleModalClick(e) {
    e.preventDefault();
    this.setState({modalShown: true});
  }

  render() {
    if(!this.state.modalShown)
      return <CreateAccountSplash cb={this.handleModalClick} />

    if(this.state.ready)
      return <Redirect to="/virtual_machines/new" />;

    return <EnableAccountForm credit_cards={this.state.credit_cards}
                              direct_debit={this.state.direct_debit}
                              payment_method={this.state.payment_method}
                              payment_method_id={this.state.payment_method_id}
                              payment_method_label={this.state.payment_method_label}
                              billing_handle_id={this.state.billing_handle_id}
                              billing_handle_label={this.state.billing_handle_label}
                              tosAccepted={this.state.tosAccepted}
                              dispatch={this.dispatch} />;
  }
}

export default CreateAccount;
